import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const Wrapper = styled(Box)({
  width: '100%',
  height: '100%',
  position: 'relative',
}) as typeof Box;

export const BackButtonBox = styled(Box)({
  width: '100%',
}) as typeof Box;

export const AuthMainBox = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',

    [theme.breakpoints.down('tablet')]: {
      justifyContent: 'flex-start',
      marginTop: '2rem',
      height: 'auto',
    },

    [theme.breakpoints.between('mobile', 'desktop')]: {
      '@media (orientation: landscape)': {
        padding: '20px 0',
      },
    },
  };
}) as typeof Box;

export const FormWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '440px',
    height: 'max-content',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },

    '> form': {
      width: '100%',
    },
  };
}) as typeof Box;

export const FormWrapperMain = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  gap: '16px',
}) as typeof Box;

export const CheckOrVerifyEmailText = styled(Typography)({
  color: palette.text.body,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '22px',
  textAlign: 'center',
  whiteSpace: 'pre-line',

  '> span': {
    color: palette.primary.purple900,
    fontWeight: 600,
    lineHeight: '21px',
  },
}) as typeof Typography;
